import { useState, useEffect, useCallback } from "react";
import { mainColor } from "./MainPage";
import {
  Box,
  Container,
  Grid,
  GridItem,
  Heading,
  Text,
  Badge,
  VStack,
  HStack,
  Button,
  Flex,
  useColorModeValue,
} from "@chakra-ui/react";

// ─── Icons ─────────────────────────────────────────────────────────────────────

const PlusIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const GridIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);
const TagIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </svg>
);
const ClockIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const LinkIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
const CalendarIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);
const ArrowRightIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const CheckIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const PlayIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);
const ChevronLeftIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const UserIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const UsersIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const InfoIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);
const StarIcon = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 24 24"
    fill="#f59e0b"
    stroke="#f59e0b"
    strokeWidth="1"
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const ImageIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <polyline points="21 15 16 10 5 21" />
  </svg>
);
const TrashIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ef4444"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
);
const EditIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#007188"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const ArchiveIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#007188"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

// ─── Shared shell ──────────────────────────────────────────────────────────────

const AppShell = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => (
  <Box
    bg="white"
    borderRadius="16px"
    overflow="hidden"
    boxShadow="0 24px 64px rgba(0,0,0,0.13)"
    w="full"
    border="1px solid #007188"
  >
    {/* Top bar */}
    <Box bg="#f7f7f7" px={3} py={2} borderBottom="1px solid #e8e8e8">
      <HStack spacing={1.5}>
        <Box w="9px" h="9px" borderRadius="full" bg="#ff5f57" />
        <Box w="9px" h="9px" borderRadius="full" bg="#febc2e" />
        <Box w="9px" h="9px" borderRadius="full" bg="#28c840" />
        <HStack
          flex="1"
          mx={2}
          bg="white"
          borderRadius="5px"
          px={2.5}
          py={0.5}
          border="1px solid #e0e0e0"
          spacing={1}
        >
          <Box
            w="5px"
            h="5px"
            borderRadius="full"
            bg="#1a7a6e"
            flexShrink={0}
          />
          <Text fontSize="9px" color="#888" fontFamily="monospace">
            app.wobble.hu / {title}
          </Text>
        </HStack>
      </HStack>
    </Box>
    {children}
  </Box>
);

// ─── Toggle component ──────────────────────────────────────────────────────────

const Toggle = ({ on }: { on: boolean }) => (
  <Box
    w="34px"
    h="18px"
    borderRadius="full"
    position="relative"
    flexShrink={0}
    bg={on ? "#007188" : "#d1d5db"}
    transition="background 0.2s"
  >
    <Box
      w="14px"
      h="14px"
      borderRadius="full"
      bg="white"
      position="absolute"
      top="2px"
      left={on ? "18px" : "2px"}
      transition="left 0.2s"
      boxShadow="0 1px 3px rgba(0,0,0,0.25)"
    />
  </Box>
);

// ─── Step 1: Booking page settings ────────────────────────────────────────────

const Step1Preview = () => (
  <AppShell title="beallitasok">
    <Box>
      {/* Tab bar */}
      <Box px={4} pt={3} pb={0} borderBottom="1px solid #e8e8e8">
        <HStack spacing={0}>
          {[
            "Profil",
            "Foglalási oldal",
            "Weboldal",
            "Beágyazás",
            "Integrációk",
            "QR kód",
          ].map((t, i) => (
            <Box
              key={t}
              px={3}
              py={2}
              cursor="pointer"
              borderBottom="2px solid"
              borderColor={i === 1 ? "#007188" : "transparent"}
              mr={1}
            >
              <Text
                fontSize="9px"
                fontWeight={i === 1 ? "700" : "500"}
                color={i === 1 ? "#007188" : "#888"}
                whiteSpace="nowrap"
              >
                {t}
              </Text>
            </Box>
          ))}
        </HStack>
      </Box>
      <Box p={4}>
        {/* Cover image area */}
        <Box
          h="70px"
          borderRadius="8px"
          overflow="hidden"
          mb={2}
          position="relative"
          bg="linear-gradient(135deg, #c9d6df 0%, #e2ebf0 100%)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          border="1px solid #e0e0e0"
        >
          {/* Lava stones effect */}
          <Box
            position="absolute"
            right="0"
            top="0"
            bottom="0"
            w="55%"
            overflow="hidden"
            opacity={0.5}
          >
            <Box
              position="absolute"
              right="-10px"
              top="-5px"
              w="60px"
              h="45px"
              borderRadius="full"
              bg="#555"
            />
            <Box
              position="absolute"
              right="30px"
              top="15px"
              w="40px"
              h="30px"
              borderRadius="full"
              bg="#444"
            />
            <Box
              position="absolute"
              right="10px"
              bottom="0px"
              w="50px"
              h="35px"
              borderRadius="full"
              bg="#666"
            />
          </Box>
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%,-50%)"
            bg="rgba(0,0,0,0.35)"
            borderRadius="5px"
            px={2}
            py={0.5}
          >
            <HStack spacing={1}>
              <ImageIcon />
              <Text fontSize="8px" color="white" fontWeight="600">
                Borítókép feltöltése
              </Text>
            </HStack>
          </Box>
        </Box>
        <HStack spacing={2} mb={3}>
          <Box bg={mainColor} borderRadius="5px" px={2} py={0.5}>
            <Text fontSize="9px" color="white" fontWeight="600">
              Sablonok
            </Text>
          </Box>
          <Box bg="#ef4444" borderRadius="5px" px={2} py={0.5}>
            <Text fontSize="9px" color="white" fontWeight="600">
              Borítókép törlése
            </Text>
          </Box>
        </HStack>
        {/* Brand colours */}
        <Box
          bg="white"
          border="1px solid #e8e8e8"
          borderRadius="8px"
          p={3}
          mb={2}
        >
          <Text fontSize="10px" fontWeight="700" color="#1a1a1a" mb={1}>
            Arculati színek
          </Text>
          <Text fontSize="8px" color="#888" mb={2} lineHeight="1.4">
            Válassz két színt a foglalási oldalad arculatához
          </Text>
          <HStack spacing={3}>
            <HStack spacing={1.5}>
              <Text fontSize="8px" color="#555">
                Világos szín
              </Text>
              <Box
                w="16px"
                h="16px"
                borderRadius="3px"
                bg="#a78bfa"
                border="1px solid #e0e0e0"
              />
            </HStack>
            <HStack spacing={1.5}>
              <Text fontSize="8px" color="#555">
                Sötét szín
              </Text>
              <Box
                w="16px"
                h="16px"
                borderRadius="3px"
                bg="#c4a882"
                border="1px solid #e0e0e0"
              />
            </HStack>
            <Box bg={mainColor} borderRadius="4px" px={2} py={0.5} ml="auto">
              <Text fontSize="8px" color="white" fontWeight="600">
                Mentés
              </Text>
            </Box>
          </HStack>
        </Box>
        {/* Booking URL */}
        <Box bg="white" border="1px solid #e8e8e8" borderRadius="8px" p={3}>
          <Text fontSize="10px" fontWeight="700" color="#1a1a1a" mb={0.5}>
            Foglalási oldal
          </Text>
          <Text fontSize="8px" color="#888" mb={1.5}>
            Foglalási oldal URL pl.: kitty-beauty
          </Text>
          <Box
            bg="#f8f8f8"
            border="1px solid"
            borderColor="#007188"
            borderRadius="5px"
            px={2}
            py={1.5}
          >
            <Text fontSize="9px" color={mainColor} fontFamily="monospace">
              kitty-beauty
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  </AppShell>
);

// ─── Step 2: Categories ────────────────────────────────────────────────────────
// Based on: 2.png — Kategóriák table with "+ Új kategória"

const Step2Preview = () => (
  <AppShell title="kategoriak">
    <Box p={4}>
      {/* Sub-tabs */}
      <HStack spacing={2} mb={3}>
        <Box
          bg="#f3f4f6"
          borderRadius="20px"
          px={3}
          py={1}
          border="1px solid #e0e0e0"
        >
          <HStack spacing={1}>
            <Text fontSize="9px">🗂️</Text>
            <Text fontSize="9px" color="#555" fontWeight="500">
              Szolgáltatások
            </Text>
          </HStack>
        </Box>
        <Box bg="#007188" borderRadius="20px" px={3} py={1}>
          <HStack spacing={1}>
            <Text fontSize="9px">📁</Text>
            <Text fontSize="9px" color="white" fontWeight="700">
              Kategóriák
            </Text>
          </HStack>
        </Box>
      </HStack>
      {/* Notice */}
      <Box
        bg="#E9F0F1"
        border="1px solid #d9d9d9"
        borderRadius="7px"
        p={2.5}
        mb={3}
      >
        <Text fontSize="8px" fontWeight="700" color="#007188" mb={0.5}>
          A kategóriák létrehozása nem kötelező.
        </Text>
        <Text fontSize="8px" color="#555" lineHeight="1.4">
          Átláthatóbban csoportosíthatod a szolgáltatásaidat helyszín vagy
          csomagok szerint.
        </Text>
      </Box>
      {/* Table header */}
      <HStack justify="space-between" mb={2}>
        <Text fontSize="11px" fontWeight="700" color="#1a1a1a">
          Kategóriák (3)
        </Text>
        <Box bg="#007188" borderRadius="6px" px={2.5} py={1}>
          <HStack spacing={1}>
            <Text fontSize="9px" color="white" fontWeight="700">
              + Új kategória
            </Text>
          </HStack>
        </Box>
      </HStack>
      <Grid templateColumns="60px 1fr 1fr 80px" gap={0}>
        {["Kép", "Kategória neve", "Leírás", "Műveletek"].map((h) => (
          <Box key={h} py={1} borderBottom="1px solid #f0f0f0">
            <Text fontSize="8px" fontWeight="700" color="#888">
              {h}
            </Text>
          </Box>
        ))}
        {[
          { emoji: "💇", name: "Hajápolás", desc: "Vágás, festés, kezelések" },
          { emoji: "💅", name: "Körömápolás", desc: "Manikűr, pedikűr" },
          { emoji: "✨", name: "Kozmetika", desc: "Arc- és testkezelések" },
        ].map((row, i) => (
          <>
            <Box
              key={`img-${i}`}
              py={1.5}
              borderBottom="1px solid #f5f5f5"
              display="flex"
              alignItems="center"
            >
              <Box
                w="22px"
                h="22px"
                borderRadius="full"
                bg="#f0f0f0"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Text fontSize="11px">{row.emoji}</Text>
              </Box>
            </Box>
            <Box
              key={`name-${i}`}
              py={1.5}
              borderBottom="1px solid #f5f5f5"
              display="flex"
              alignItems="center"
            >
              <Text fontSize="9px" color="#1a1a1a" fontWeight="500">
                {row.name}
              </Text>
            </Box>
            <Box
              key={`desc-${i}`}
              py={1.5}
              borderBottom="1px solid #f5f5f5"
              display="flex"
              alignItems="center"
            >
              <Text fontSize="8px" color="#888">
                {row.desc}
              </Text>
            </Box>
            <Box
              key={`act-${i}`}
              py={1.5}
              borderBottom="1px solid #f5f5f5"
              display="flex"
              alignItems="center"
            >
              <HStack spacing={2}>
                <EditIcon />
                <ArchiveIcon />
              </HStack>
            </Box>
          </>
        ))}
      </Grid>
    </Box>
  </AppShell>
);

// ─── Step 3: New Service form ──────────────────────────────────────────────────
// Based on: 4.png — "Új szolgáltatás" full form

const Step3Preview = () => (
  <AppShell title="szolgaltatasok">
    <Box p={4}>
      <HStack justify="space-between" mb={3}>
        <HStack spacing={1}>
          <ChevronLeftIcon />
          <Text fontSize="9px" color="#007188" fontWeight="600">
            Vissza
          </Text>
        </HStack>
        <HStack spacing={2}>
          <Box border="1px solid #e0e0e0" borderRadius="5px" px={2.5} py={1}>
            <Text fontSize="9px" color="#555">
              Mégse
            </Text>
          </Box>
          <Box bg="#007188" borderRadius="5px" px={2.5} py={1}>
            <Text fontSize="9px" color="white" fontWeight="700">
              Mentés
            </Text>
          </Box>
        </HStack>
      </HStack>
      <Text fontSize="12px" fontWeight="800" color="#1a1a1a" mb={3}>
        Új szolgáltatás
      </Text>
      {/* Service type */}
      <Box border="1px solid #e0e0e0" borderRadius="8px" p={2.5} mb={2}>
        <Text
          fontSize="8px"
          color="#888"
          mb={1}
          fontWeight="600"
          textTransform="uppercase"
          letterSpacing="0.05em"
        >
          Szolgáltatás típusa
        </Text>
        <Text fontSize="9px" color="#1a1a1a">
          Egyéni foglalás
        </Text>
      </Box>
      {/* Details */}
      <Box border="1px solid #e0e0e0" borderRadius="8px" p={2.5} mb={2}>
        <Text fontSize="9px" fontWeight="700" color="#1a1a1a" mb={2}>
          Szolgáltatás részletei
        </Text>
        <Box
          bg="#f8f8f8"
          border="1px solid #e0e0e0"
          borderRadius="5px"
          px={2}
          py={1}
          mb={1.5}
        >
          <Text fontSize="8px" color="#aaa">
            Szolgáltatás neve
          </Text>
        </Box>
        <Box
          bg="#f8f8f8"
          border="1px solid #e0e0e0"
          borderRadius="5px"
          px={2}
          py={1}
          mb={1.5}
        >
          <Text fontSize="8px" color="#aaa">
            Rövid leírás (0/80)
          </Text>
        </Box>
        <Grid templateColumns="1fr 1fr" gap={1.5}>
          <Box>
            <Text fontSize="7px" color="#888" mb={0.5}>
              Időtartam
            </Text>
            <Box
              bg="#f8f8f8"
              border="1px solid #e0e0e0"
              borderRadius="5px"
              px={2}
              py={1}
            >
              <Text fontSize="8px" color="#555">
                30 perc
              </Text>
            </Box>
          </Box>
          <Box>
            <Text fontSize="7px" color="#888" mb={0.5}>
              Szünet
            </Text>
            <Box
              bg="#f8f8f8"
              border="1px solid #e0e0e0"
              borderRadius="5px"
              px={2}
              py={1}
            >
              <Text fontSize="8px" color="#555">
                0 perc
              </Text>
            </Box>
          </Box>
        </Grid>
      </Box>
      {/* Price */}
      <Box border="1px solid #e0e0e0" borderRadius="8px" p={2.5} mb={2}>
        <Text fontSize="9px" fontWeight="700" color="#1a1a1a" mb={1.5}>
          Szolgáltatás ára
        </Text>
        <Grid templateColumns="1fr 1fr" gap={1.5}>
          <Box
            border="1px solid"
            borderColor="#007188"
            borderRadius="6px"
            p={2}
          >
            <Text
              textAlign="center"
              fontSize="9px"
              fontWeight="700"
              color="#1a1a1a"
            >
              Ingyenes
            </Text>
            <Text textAlign="center" fontSize="7px" color="#888">
              Nincs ár megjelenítve
            </Text>
          </Box>
          <Box border="1px solid #e0e0e0" borderRadius="6px" p={2}>
            <Text
              textAlign="center"
              fontSize="9px"
              fontWeight="600"
              color="#555"
            >
              Per alkalom
            </Text>
            <Text textAlign="center" fontSize="7px" color="#aaa">
              Fizetős foglalás
            </Text>
          </Box>
        </Grid>
      </Box>
      {/* Location */}
      <Box border="1px solid #e0e0e0" borderRadius="8px" p={2.5}>
        <Text fontSize="9px" fontWeight="700" color="#1a1a1a" mb={1.5}>
          Helyszín
        </Text>
        <Grid templateColumns="repeat(3, 1fr)" gap={1}>
          {[
            { l: "Nincs", s: "Nincs helyszín" },
            { l: "Helyszín", s: "Fizikai cím" },
            { l: "Videókonferencia", s: "Online link" },
          ].map((loc, i) => (
            <Box
              key={i}
              border={i === 0 ? "1px solid #007188" : "1px solid #e0e0e0"}
              borderRadius="5px"
              p={1.5}
              textAlign="center"
            >
              <Text fontSize="8px" fontWeight={i === 0 ? "700" : "500"}>
                {loc.l}
              </Text>
              <Text fontSize="6px" color="#aaa">
                {loc.s}
              </Text>
            </Box>
          ))}
        </Grid>
      </Box>
    </Box>
  </AppShell>
);

// ─── Step 4: Schedule / timing ────────────────────────────────────────────────

const Step4Preview = () => {
  const days = [
    { label: "HÉTFŐ", on: false, slots: [] },
    { label: "KEDD", on: true, slots: [{ from: "8:00", to: "17:00" }] },
    { label: "SZERDA", on: false, slots: [] },
    { label: "CSÜTÖRTÖK", on: true, slots: [{ from: "10:00", to: "12:00" }] },
    { label: "PÉNTEK", on: false, slots: [] },
    { label: "SZOMBAT", on: false, slots: [] },
    { label: "VASÁRNAP", on: false, slots: [] },
  ];
  return (
    <AppShell title="beallitasok">
      <Box p={4}>
        <HStack spacing={1} mb={1}>
          <ChevronLeftIcon />
          <Text fontSize="9px" color="#1a7a6e" fontWeight="600">
            Vissza
          </Text>
        </HStack>
        <Text fontSize="12px" fontWeight="800" color="#1a1a1a" mb={0.5}>
          Stresszoldó workshop
        </Text>
        <Box border="1px solid #e0e0e0" borderRadius="10px" p={3}>
          <Text fontSize="10px" fontWeight="700" color="#1a1a1a" mb={0.5}>
            Ütemezés
          </Text>
          <Text fontSize="8px" color="#888" mb={2.5}>
            Heti tervezés
          </Text>
          <VStack
            spacing={0}
            align="stretch"
            divider={<Box h="1px" bg="#f0f0f0" />}
          >
            {days.map((d, i) => (
              <Box key={i} py={2}>
                <HStack spacing={2} mb={d.on ? 1.5 : 0}>
                  <Toggle on={d.on} />
                  <Text
                    fontSize="9px"
                    fontWeight="700"
                    color={d.on ? "#1a1a1a" : "#bbb"}
                    letterSpacing="0.04em"
                  >
                    {d.label}
                  </Text>
                </HStack>
                {d.on &&
                  d.slots.map((slot, si) => (
                    <>
                      <HStack key={si} spacing={1} ml={6} mt={si > 0 ? 1 : 0}>
                        {[slot.from.split(":")[0], slot.from.split(":")[1]].map(
                          (v, vi) => (
                            <Box
                              key={vi}
                              bg="white"
                              border="1px solid #d1d5db"
                              borderRadius="5px"
                              w="22px"
                              h="20px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Text fontSize="9px" color="#1a1a1a">
                                {v}
                              </Text>
                            </Box>
                          )
                        )}
                        <Text fontSize="9px" color="#888">
                          -
                        </Text>
                        {[slot.to.split(":")[0], slot.to.split(":")[1]].map(
                          (v, vi) => (
                            <Box
                              key={vi}
                              bg="white"
                              border="1px solid #d1d5db"
                              borderRadius="5px"
                              w="22px"
                              h="20px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Text fontSize="9px" color="#1a1a1a">
                                {v}
                              </Text>
                            </Box>
                          )
                        )}
                        <Box
                          w="16px"
                          h="16px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Text fontSize="10px" color="#ef4444">
                            ⊗
                          </Text>
                        </Box>
                      </HStack>
                      <Box
                        border="1px solid #007188"
                        borderRadius="12px"
                        px={1.5}
                        py={0.5}
                        ml={1}
                        mt={4}
                        w="70px"
                      >
                        <Text fontSize="7px" color={mainColor} fontWeight="600">
                          ⊕ Új hozzáadás
                        </Text>
                      </Box>
                    </>
                  ))}
              </Box>
            ))}
          </VStack>
          <HStack spacing={2} mt={2}>
            <Box bg={mainColor} borderRadius="6px" px={3} py={1}>
              <Text fontSize="9px" color="white" fontWeight="700">
                Mentés
              </Text>
            </Box>
            <Box border="1px solid #e0e0e0" borderRadius="6px" px={3} py={1}>
              <Text fontSize="9px" color="#555">
                Bezár
              </Text>
            </Box>
          </HStack>
        </Box>
      </Box>
    </AppShell>
  );
};

// ─── Step 5: Public booking portal ────────────────────────────────────────────
// Based on: 1.png / Screenshot_11_14_49 — Customer-facing portal

const Step5Preview = () => (
  <AppShell title="portal / masszazs">
    <Box>
      {/* Cover image */}
      <Box
        h="58px"
        position="relative"
        overflow="hidden"
        bg="linear-gradient(135deg, #c9d6df 0%, #e8edf0 50%, #b8c8ce 100%)"
      >
        <Box
          position="absolute"
          right="0"
          top="0"
          bottom="0"
          w="60%"
          overflow="hidden"
          opacity={0.6}
        >
          <Box
            position="absolute"
            right="-5px"
            top="-8px"
            w="70px"
            h="55px"
            borderRadius="full"
            bg="#444"
          />
          <Box
            position="absolute"
            right="35px"
            top="10px"
            w="45px"
            h="38px"
            borderRadius="full"
            bg="#333"
          />
          <Box
            position="absolute"
            right="15px"
            bottom="-5px"
            w="55px"
            h="40px"
            borderRadius="full"
            bg="#555"
          />
          <Box
            position="absolute"
            right="60px"
            top="-2px"
            w="35px"
            h="28px"
            borderRadius="full"
            bg="#666"
          />
        </Box>
        {/* Logo card */}
        <Box
          position="absolute"
          top="8px"
          left="10px"
          bg="white"
          borderRadius="8px"
          w="36px"
          h="36px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="0 2px 8px rgba(0,0,0,0.15)"
        >
          <Text fontSize="14px">🪷</Text>
        </Box>
      </Box>
      <Box display="flex">
        {/* Left sidebar */}
        <Box
          w="100px"
          borderRight="1px solid #f0f0f0"
          p={2}
          bg="white"
          flexShrink={0}
        >
          <Text fontSize="9px" fontWeight="700" color="#1a1a1a" mb={0.5}>
            Test-lélek masszázs
          </Text>
          <HStack spacing={0.5} mb={2}>
            {[1, 2, 3, 4, 5].map((s) => (
              <StarIcon key={s} />
            ))}
            <Text fontSize="7px" color="#888">
              (11)
            </Text>
          </HStack>
          <Box bg="#7c5cbf" borderRadius="6px" px={2} py={1} mb={1}>
            <HStack spacing={1}>
              <Text fontSize="8px">📅</Text>
              <Text fontSize="8px" color="white" fontWeight="600">
                Időpontfoglalás
              </Text>
            </HStack>
          </Box>
          {["Rólam", "Galéria", "Értékelések"].map((m, i) => (
            <HStack key={i} spacing={1} py={1} px={1}>
              <Text fontSize="9px">{["ℹ️", "🖼️", "⭐"][i]}</Text>
              <Text fontSize="8px" color="#555">
                {m}
              </Text>
            </HStack>
          ))}
          <Box mt={3} pt={2} borderTop="1px solid #f0f0f0">
            <Text fontSize="7px" color="#1a7a6e" fontWeight="600">
              MyWobble
            </Text>
            <Text fontSize="6px" color="#aaa" lineHeight="1.3">
              minden időpontod egy helyen
            </Text>
          </Box>
          <Box mt={1}>
            <Text fontSize="6px" color="#aaa">
              Powered by wobble
            </Text>
          </Box>
        </Box>
        {/* Main */}
        <Box flex="1" p={2.5}>
          {/* Step indicator */}
          <HStack spacing={0} justify="center" mb={2.5}>
            {[
              { n: 1, l: "Szolgáltatás" },
              { n: 2, l: "Dátum & idő" },
              { n: 3, l: "Részletek" },
              { n: 4, l: "Visszaigazolás" },
            ].map((s, i) => (
              <HStack key={i} spacing={0}>
                <VStack spacing={0.5}>
                  <Box
                    w="18px"
                    h="18px"
                    borderRadius="full"
                    bg={s.n === 1 ? "#7c5cbf" : "#e5e7eb"}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text
                      fontSize="8px"
                      color={s.n === 1 ? "white" : "#9ca3af"}
                      fontWeight="700"
                    >
                      {s.n}
                    </Text>
                  </Box>
                  <Text
                    fontSize="6px"
                    color={s.n === 1 ? "#7c5cbf" : "#9ca3af"}
                    whiteSpace="nowrap"
                  >
                    {s.l}
                  </Text>
                </VStack>
                {i < 3 && <Box w="20px" h="1px" bg="#e5e7eb" mb="10px" />}
              </HStack>
            ))}
          </HStack>
          {/* Service selection */}
          <Box border="1px solid #e8e8e8" borderRadius="8px" p={2}>
            <Text fontSize="9px" fontWeight="700" color="#1a1a1a" mb={1.5}>
              Válassz szolgáltatást
            </Text>
            <Grid templateColumns="1fr 1fr" gap={1.5} mb={1.5}>
              {[
                {
                  name: "Különleges masszázs",
                  type: "Egyéni",
                  time: "1 óra",
                  price: "9 900 Ft",
                  emoji: "💆",
                },
                {
                  name: "Lávaköves masszázs",
                  type: "Egyéni",
                  time: "50 perc",
                  price: "8 000 Ft",
                  emoji: "🪨",
                },
                {
                  name: "Stresszoldó workshop (3 fő)",
                  type: "Csoportos",
                  time: "120 perc",
                  price: "4 000 Ft",
                  emoji: "🧘",
                },
              ].map((svc, i) => (
                <Box
                  key={i}
                  border="1px solid #e8e8e8"
                  borderRadius="6px"
                  p={1.5}
                  position="relative"
                >
                  <HStack spacing={1} mb={0.5}>
                    <Box
                      w="18px"
                      h="18px"
                      borderRadius="full"
                      bg="#f0f0f0"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Text fontSize="10px">{svc.emoji}</Text>
                    </Box>
                    <Text
                      fontSize="8px"
                      fontWeight="600"
                      color="#1a1a1a"
                      lineHeight="1.2"
                    >
                      {svc.name}
                    </Text>
                    <Box
                      position="absolute"
                      top={1.5}
                      right={1.5}
                      color="#9ca3af"
                    >
                      <InfoIcon />
                    </Box>
                  </HStack>
                  <HStack spacing={0.5} mb={0.5}>
                    <UserIcon />
                    <Text fontSize="7px" color="#888">
                      {svc.type}
                    </Text>
                  </HStack>
                  <HStack justify="space-between">
                    <Text fontSize="7px" color="#888">
                      {svc.time}
                    </Text>
                    <Text fontSize="8px" fontWeight="700" color="#1a1a1a">
                      {svc.price}
                    </Text>
                  </HStack>
                </Box>
              ))}
            </Grid>
            <Box bg="#7c5cbf" borderRadius="7px" py={1.5} textAlign="center" w="160px">
              <Text fontSize="9px" color="white" fontWeight="700">
                Tovább a dátum &amp; időre
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  </AppShell>
);

// ─── Step 6: Weekly calendar ───────────────────────────────────────────────────
// Based on: Screenshot_2026-05-22_at_11_19_09.png — heti nézet with appointments

const Step6Preview = () => {
  const days = [
    "27. hétfő",
    "28. kedd",
    "29. szerda",
    "30. csüt.",
    "01. péntek",
    "02. szomb.",
  ];
  const appointments = [
    {
      day: 3,
      top: 55,
      h: 18,
      label: "9:00 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 4,
      top: 99,
      h: 18,
      label: "10:20 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 3,
      top: 90,
      h: 58,
      label: "10:00 Stresszoldó",
      color: "#ddd6fe",
      border: "#7c3aed",
    },
    {
      day: 2,
      top: 90,
      h: 58,
      label: "10:00 Stresszoldó",
      color: "#ddd6fe",
      border: "#7c3aed",
    },
    {
      day: 1,
      top: 90,
      h: 58,
      label: "11:00 Stresszoldó",
      color: "#ddd6fe",
      border: "#7c3aed",
    },
    {
      day: 1,
      top: 90,
      h: 18,
      label: "10:00 Stresszoldó",
      color: "#ddd6fe",
      border: "#7c3aed",
    },
    {
      day: 0,
      top: 69,
      h: 18,
      label: "9:30 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 0,
      top: 90,
      h: 58,
      label: "10:00 Stresszoldó",
      color: "#ddd6fe",
      border: "#7c3aed",
    }, 
    {
      day: 0,
      top: 69,
      h: 18,
      label: "9:30 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 0,
      top: 159,
      h: 18,
      label: "12:00 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 0,
      top: 159,
      h: 38,
      label: "12:00 Különleges masszázs",
      color: "#5AB3C5",
      border: "#007188",
    },
    {
      day: 3,
      top: 159,
      h: 38,
      label: "12:00 Különleges masszázs",
      color: "#5AB3C5",
      border: "#007188",
    },
    {
      day: 2,
      top: 179,
      h: 18,
      label: "12:30 Lávaköves",
      color: "#bbf7d0",
      border: "#16a34a",
    },
    {
      day: 4,
      top: 179,
      h: 38,
      label: "12:30 Különleges masszázs",
      color: "#5AB3C5",
      border: "#007188",
    },
  ];
  const hours = ["08:00", "09:00", "10:00", "11:00", "12:00", "13:00"];
  return (
    <AppShell title="calendar">
      <Box p={3}>
        {/* Toolbar */}
        <HStack justify="space-between" mb={2}>
          <HStack spacing={2}>
            <Box bg="#007188" borderRadius="5px" px={2} py={1}>
              <Text fontSize="8px" color="white" fontWeight="700">
                Ma
              </Text>
            </Box>
            <HStack spacing={1}>
              <Box
                border="1px solid #e0e0e0"
                borderRadius="4px"
                w="18px"
                h="18px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
              >
                <ChevronLeftIcon />
              </Box>
              <Box
                border="1px solid #e0e0e0"
                borderRadius="4px"
                w="18px"
                h="18px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                cursor="pointer"
              >
                <ChevronRightIcon />
              </Box>
            </HStack>
            <Text fontSize="9px" fontWeight="600" color="#007188">
              2026. ápr. 27. – máj. 3.
            </Text>
          </HStack>
          <HStack spacing={1}>
            {["havi", "heti", "lista"].map((v, i) => (
              <Box
                key={v}
                bg={i === 1 ? "#007188" : "#f0f0f0"}
                borderRadius="4px"
                px={2}
                py={0.5}
              >
                <Text
                  fontSize="8px"
                  color={i === 1 ? "white" : "#555"}
                  fontWeight={i === 1 ? "700" : "400"}
                >
                  {v}
                </Text>
              </Box>
            ))}
          </HStack>
        </HStack>
        {/* Calendar grid */}
        <Box position="relative" overflow="hidden">
          {/* Day headers */}
          <Grid templateColumns={`36px repeat(${days.length}, 1fr)`} mb={0}>
            <Box />
            {days.map((d, i) => (
              <Box
                key={i}
                textAlign="center"
                py={1}
                borderBottom="1px solid #e8e8e8"
                borderLeft="1px solid #f0f0f0"
              >
                <Text fontSize="7px" color="#888">
                  {d}
                </Text>
              </Box>
            ))}
          </Grid>
          {/* Time slots */}
          {hours.map((h, hi) => (
            <Grid
              key={hi}
              templateColumns={`36px repeat(${days.length}, 1fr)`}
              h="34px"
            >
              <Box display="flex" alignItems="start" pt={0.5}>
                <Text fontSize="7px" color="#007188" fontFamily="monospace">
                  {h}
                </Text>
              </Box>
              {days.map((_, di) => (
                <Box
                  key={di}
                  borderTop="1px solid #f0f0f0"
                  borderLeft="1px solid #f5f5f5"
                  position="relative"
                />
              ))}
            </Grid>
          ))}
          {/* Appointment overlays */}
          {appointments.map((apt, i) => (
            <Box
              key={i}
              position="absolute"
              top={`${apt.top}px`}
              left={`${24 + (apt.day / days.length) * (100 - 34 / 4)}%`}
              w={`${(1 / days.length) * 85}%`}
              h={`${apt.h}px`}
              bg={apt.color}
              borderRadius="4px"
              borderLeft="3px solid"
              borderColor={apt.border}
              px={1}
              py={0.5}
              overflow="hidden"
            >
              <Text
                fontSize="6.5px"
                fontWeight="600"
                color="#1a1a1a"
                lineHeight="1.3"
                noOfLines={2}
              >
                {apt.label}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </AppShell>
  );
};

// ─── Steps Data ────────────────────────────────────────────────────────────────

interface Feature {
  label: string;
  icon: React.ReactNode;
}
interface Step {
  id: number;
  label: string;
  title: string;
  description: string;
  detail: string;
  icon: React.ReactNode;
  duration: string;
  preview: React.ReactNode;
}

const steps: Step[] = [
  {
    id: 1,
    label: "1. lépés",
    title: "Foglalási oldal beállítása",
    description:
      "Add meg a vállalkozásod nevét, tölts fel borítóképet, válassz arculati színeket és állítsd be az egyedi foglalási URL-t.",
    detail:
      "Profil, Foglalási oldal, Weboldal, Beágyazás, Integrációk — minden egy helyen.",
    icon: <PlusIcon />,
    duration: "~8 perc",
    preview: <Step1Preview />,
  },
  {
    id: 2,
    label: "2. lépés",
    title: "Kategóriák beállítása",
    description:
      "Csoportosítsd a szolgáltatásaidat helyszín vagy csomagok szerint. Nem kötelező, de átláthatóbbá teszi a foglalási oldalt.",
    detail: "Korlátlan kategória, egyedi képpel és leírással.",
    icon: <GridIcon />,
    duration: "~5 perc",
    preview: <Step2Preview />,
  },
  {
    id: 3,
    label: "3. lépés",
    title: "Szolgáltatások hozzáadása",
    description:
      "Add meg a szolgáltatás nevét, típusát, időtartamát, árát, helyszínét és várólistáját. Egyéni és csoportos foglalás is elérhető.",
    detail: "Ingyenes vagy fizetős, fizikai helyszín vagy videókonferencia.",
    icon: <TagIcon />,
    duration: "~15 perc",
    preview: <Step3Preview />,
  },
  {
    id: 4,
    label: "4. lépés",
    title: "Munkaidő beállítása",
    description:
      "Kapcsold be az aktív napokat és add meg a nyitvatartási időket. Naponként több időszak is megadható.",
    detail:
      "Heti tervezés, szünetek, és egyedi időpontok tetszőleges kombinációja.",
    icon: <ClockIcon />,
    duration: "~6 perc",
    preview: <Step4Preview />,
  },
  {
    id: 5,
    label: "5. lépés",
    title: "Link megosztása — jönnek a foglalások",
    description:
      "Az ügyfeleid a te foglalási oldaladon kiválasztják a szolgáltatást, időpontot és megadják az adataikat — minden automatikus.",
    detail:
      "Egyéni és csoportos foglalás, 4 lépéses folyamat, azonnali visszaigazolás.",
    icon: <LinkIcon />,
    duration: "1 perc",
    preview: <Step5Preview />,
  },
  {
    id: 6,
    label: "6. lépés",
    title: "Naptár & foglalások kezelése",
    description:
      "Kövesd az összes foglalást heti vagy havi nézetben. Minden esemény kattintható, szerkeszthető és exportálható.",
    detail:
      "Havi / heti / lista nézet, színkódolt szolgáltatások, azonnali értesítések.",
    icon: <CalendarIcon />,
    duration: "folyamatos",
    preview: <Step6Preview />,
  },
];

// ─── Main Component ────────────────────────────────────────────────────────────

export default function WobbleSetupSteps() {
  const [activeStep, setActiveStep] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [animating, setAnimating] = useState(false);

  const goToStep = useCallback(
    (idx: number) => {
      if (idx === activeStep) return;
      setAnimating(true);
      setTimeout(() => {
        setActiveStep(idx);
        setAnimating(false);
      }, 180);
    },
    [activeStep]
  );

  useEffect(() => {
    if (!isAutoPlaying) return;
    const timer = setInterval(
      () => setActiveStep((prev) => (prev + 1) % steps.length),
      3400
    );
    return () => clearInterval(timer);
  }, [isAutoPlaying]);

  const step = steps[activeStep];
  const sectionBg = useColorModeValue("#f8faf9", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const mutedText = useColorModeValue("gray.500", "gray.400");

  return (
    <Box
      as="section"
      aria-label="Hogyan használd a Wobble-t — beállítási lépések"
      bg={sectionBg}
      py={{ base: 16, md: 24 }}
      px={{ base: 4, md: 8 }}
      position="relative"
      overflow="hidden"
    >
      <Box
        position="absolute"
        top="-160px"
        left="-100px"
        w="480px"
        h="480px"
        borderRadius="full"
        bg="radial-gradient(circle, rgba(26,122,110,0.07) 0%, transparent 70%)"
        pointerEvents="none"
      />
      <Box
        position="absolute"
        bottom="-100px"
        right="-60px"
        w="360px"
        h="360px"
        borderRadius="full"
        bg="radial-gradient(circle, rgba(13,148,97,0.05) 0%, transparent 70%)"
        pointerEvents="none"
      />

      <Container maxW="1200px" position="relative">
        {/* Header */}
        <VStack spacing={4} mb={{ base: 12, md: 16 }} textAlign="center">
          <Badge
            bg="rgba(26,122,110,0.1)"
            color="#007188"
            px={4}
            py={1.5}
            borderRadius="full"
            fontSize="xs"
            fontWeight="700"
            letterSpacing="0.08em"
            textTransform="uppercase"
          >
            Egyszerű indulás
          </Badge>
          <Heading
            as="h2"
            fontSize={{ base: "3xl", md: "5xl" }}
            fontWeight="400"
            color="gray.800"
            lineHeight="1.1"
            letterSpacing="-0.02em"
            fontFamily="'poppins', serif"
          >
            csak 6 lépés
          </Heading>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color={mutedText}
            maxW="520px"
            lineHeight="1.7"
          >
            Nincs fejlesztő, nincs bonyolult telepítés. Az első foglalás akár ma
            megérkezhet.
          </Text>
        </VStack>

        {/* Two-column layout */}
        <Grid
          templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
          gap={{ base: 8, lg: 14 }}
          alignItems="start"
        >
          {/* LEFT: Step list */}
          <GridItem>
            <VStack spacing={2} align="stretch">
              {steps.map((s, idx) => {
                const isActive = idx === activeStep;
                const isDone = idx < activeStep;
                return (
                  <Box
                    key={s.id}
                    as="button"
                    onClick={() => {
                      setIsAutoPlaying(false);
                      goToStep(idx);
                    }}
                    textAlign="left"
                    bg={isActive ? cardBg : "transparent"}
                    borderRadius="16px"
                    border="1.5px solid"
                    borderColor={isActive ? "#007188" : "transparent"}
                    boxShadow={
                      isActive ? "0 4px 24px rgba(26,122,110,0.12)" : "none"
                    }
                    px={{ base: 4, md: 5 }}
                    py={isActive ? { base: 4, md: 5 } : 3}
                    transition="all 0.22s ease"
                    _hover={{
                      bg: isActive ? cardBg : "rgba(26,122,110,0.04)",
                      borderColor: isActive
                        ? "#007188"
                        : "rgba(26,122,110,0.2)",
                    }}
                    cursor="pointer"
                    aria-pressed={isActive}
                    aria-label={`${s.label}: ${s.title}`}
                    role="tab"
                  >
                    <HStack spacing={4} align={isActive ? "start" : "center"}>
                      <Flex
                        w="40px"
                        h="40px"
                        borderRadius="12px"
                        flexShrink={0}
                        align="center"
                        justify="center"
                        bg={
                          isDone
                            ? "#007188"
                            : isActive
                            ? "rgba(26,122,110,0.12)"
                            : "rgba(0,0,0,0.04)"
                        }
                        color={
                          isDone ? "white" : isActive ? "#007188" : "gray.400"
                        }
                        transition="all 0.22s"
                        boxShadow={
                          isActive ? "0 2px 12px rgba(26,122,110,0.2)" : "none"
                        }
                      >
                        {isDone ? <CheckIcon /> : s.icon}
                      </Flex>
                      <Box flex="1" minW={0}>
                        <HStack
                          spacing={2}
                          mb={isActive ? 1 : 0}
                          flexWrap="wrap"
                        >
                          <Text
                            fontSize="11px"
                            fontWeight="700"
                            color={isActive ? "#007188" : mutedText}
                            textTransform="uppercase"
                            letterSpacing="0.06em"
                          >
                            {s.label}
                          </Text>
                          <Badge
                            bg={isActive ? "rgba(26,122,110,0.1)" : "gray.100"}
                            color={isActive ? "#007188" : "gray.500"}
                            fontSize="9px"
                            fontWeight="600"
                            px={1.5}
                            py={0.5}
                            borderRadius="full"
                          >
                            ⏱ {s.duration}
                          </Badge>
                        </HStack>
                        <Text
                          fontSize={{ base: "sm", md: "md" }}
                          fontWeight="700"
                          color={isActive ? "gray.800" : "gray.600"}
                          lineHeight="1.3"
                          mb={isActive ? 1.5 : 0}
                          noOfLines={isActive ? undefined : 1}
                        >
                          {s.title}
                        </Text>
                        {isActive && (
                          <Box
                            overflow="hidden"
                            style={{
                              maxHeight: animating ? "0px" : "120px",
                              opacity: animating ? 0 : 1,
                              transition:
                                "max-height 0.28s ease, opacity 0.22s ease",
                            }}
                          >
                            <Text
                              fontSize="sm"
                              color={mutedText}
                              lineHeight="1.6"
                              mb={1}
                            >
                              {s.description}
                            </Text>
                            <Text
                              fontSize="xs"
                              color="#007188"
                              fontWeight="600"
                            >
                              ✓ {s.detail}
                            </Text>
                          </Box>
                        )}
                      </Box>
                      <Box
                        color={isActive ? "#007188" : "gray.300"}
                        opacity={isActive ? 1 : 0.5}
                        flexShrink={0}
                        transition="all 0.22s"
                        transform={
                          isActive ? "translateX(0)" : "translateX(-4px)"
                        }
                      >
                        <ArrowRightIcon />
                      </Box>
                    </HStack>
                  </Box>
                );
              })}
            </VStack>

            {/* Auto-play controls */}
            <HStack
              mt={4}
              spacing={3}
              justify={{ base: "center", lg: "start" }}
            >
              <Button
                size="xs"
                variant="ghost"
                color={mutedText}
                fontSize="11px"
                fontWeight="600"
                leftIcon={
                  isAutoPlaying ? (
                    <Box w="8px" h="8px" borderRadius="1px" bg="currentColor" />
                  ) : (
                    <PlayIcon />
                  )
                }
                onClick={() => setIsAutoPlaying((p) => !p)}
                _hover={{ color: "#007188", bg: "rgba(26,122,110,0.06)" }}
                px={3}
              >
                {isAutoPlaying ? "Szünet" : "Autolejátszás"}
              </Button>
              <HStack spacing={1.5}>
                {steps.map((_, i) => (
                  <Box
                    key={i}
                    as="button"
                    onClick={() => {
                      setIsAutoPlaying(false);
                      goToStep(i);
                    }}
                    w={i === activeStep ? "20px" : "6px"}
                    h="6px"
                    borderRadius="full"
                    bg={i === activeStep ? "#007188" : "gray.300"}
                    transition="all 0.22s ease"
                    cursor="pointer"
                    aria-label={`${i + 1}. lépés`}
                  />
                ))}
              </HStack>
            </HStack>
          </GridItem>

          {/* RIGHT: Live preview */}
          <GridItem display={{ base: "none", lg: "block" }}>
            <Box position="sticky" top="100px">
              <HStack spacing={2} mb={4}>
                <Box w="8px" h="8px" borderRadius="full" bg="#007188" />
                <Text
                  fontSize="11px"
                  fontWeight="700"
                  color="#007188"
                  textTransform="uppercase"
                  letterSpacing="0.08em"
                >
                  Élő előnézet — {step.label}
                </Text>
              </HStack>
              <Box
                style={{
                  opacity: animating ? 0 : 1,
                  transform: animating ? "translateY(10px)" : "translateY(0)",
                  transition: "opacity 0.2s ease, transform 0.22s ease",
                }}
              >
                {step.preview}
              </Box>
              <Box
                mt={5}
                bg="gray.100"
                borderRadius="full"
                h="4px"
                overflow="hidden"
              >
                <Box
                  h="full"
                  bg="linear-gradient(90deg, #007188, #024856)"
                  borderRadius="full"
                  style={{
                    width: `${((activeStep + 1) / steps.length) * 100}%`,
                    transition: "width 0.35s ease",
                  }}
                />
              </Box>
              <HStack justify="space-between" mt={1.5}>
                <Text fontSize="10px" color={mutedText}>
                  {activeStep + 1} / {steps.length} lépés
                </Text>
                <Text fontSize="10px" color="#007188" fontWeight="600">
                  {Math.round(((activeStep + 1) / steps.length) * 100)}% kész
                </Text>
              </HStack>
            </Box>
          </GridItem>
        </Grid>

        {/* CTA */}
        <Box
          mt={{ base: 14, md: 20 }}
          bg="linear-gradient(135deg, #007188 0%, #0d5c52 100%)"
          borderRadius="24px"
          p={{ base: 8, md: 10 }}
          position="relative"
          overflow="hidden"
        >
          <Box
            position="absolute"
            top="-60px"
            right="-60px"
            w="220px"
            h="220px"
            borderRadius="full"
            bg="rgba(255,255,255,0.05)"
            pointerEvents="none"
          />
          <Box
            position="absolute"
            bottom="-40px"
            left="-40px"
            w="160px"
            h="160px"
            borderRadius="full"
            bg="rgba(255,255,255,0.04)"
            pointerEvents="none"
          />
          <Flex
            direction={{ base: "column", md: "row" }}
            align={{ base: "start", md: "center" }}
            justify="space-between"
            gap={6}
            position="relative"
          >
            <VStack spacing={1.5} align="start">
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="800"
                color="white"
                lineHeight="1.2"
              >
                Ne csak tervezz - próbáld ki ingyen 30 napig!
              </Text>
              <Text fontSize="sm" color="rgba(255,255,255,0.7)">
                Bankkártya nem szükséges. Bármikor lemondható.
              </Text>
            </VStack>
            <Button
              as="a"
              href="https://app.wobble.hu/signup_page"
              size="lg"
              bg="white"
              color="#007188"
              borderRadius="14px"
              fontWeight="800"
              fontSize="sm"
              px={8}
              py={6}
              flexShrink={0}
              rightIcon={<ArrowRightIcon />}
              _hover={{
                bg: "rgba(255,255,255,0.92)",
                transform: "translateX(3px)",
              }}
              transition="all 0.2s"
              boxShadow="0 4px 20px rgba(0,0,0,0.15)"
            >
              Regisztrálj és próbáld ki →
            </Button>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
}
